<template>
  <v-app>
    <v-layout row justify-center>
      <v-flex class="pl-4 pr-4 mt-3 mb-4" xs12 sm11>
        <v-card>

          <v-toolbar color="grey" dark>
            <v-toolbar-title>
              Estadísticas
            </v-toolbar-title>

            <v-spacer></v-spacer>
          </v-toolbar>
          <v-data-table
            :headers="headers"
            :items="totalesSalas"
            :items-per-page="11"
            disable-pagination
            hide-default-footer
            class="elevation-1"
          >
            <template slot="body.append">
              <tr class="">
                  <th class="title">Totales</th>
                  <th class="title">{{ sumField('tocas_count') }}</th>
                  <th class="title">{{ sumField('parte_toca_count') }}</th>
                  <th class="title">{{ sumField('parte_toca_no_validada') }}</th>
                  <th class="title">{{ sumField('parte_toca_pending') }}</th>
                  <th class="title">{{ sumField('notificaciones_count') }}</th>
                  <th class="title">{{ sumField('notificaciones_parte_no_validada') }}</th>
                  <th class="title">{{ sumField('notificaciones_opened') }}</th>
              </tr>
            </template>
          
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
const Swal = require('sweetalert2');
export default {

  data() {
    return {
      changePassword:false,
      mask: '##########',
      celular: '',
      valid: true,
      dialog: false,
      loading:false, //component
      show: false,
      headers: [
          {
            text: 'Salas',
            align: 'start',
            sortable: false,
            value: 'nombre',
          },
          { text: 'Tocas', value: 'tocas_count' },
          { text: 'Solicitudes Totales', value: 'parte_toca_count' },
          { text: 'Solicitudes (no validadas)', value: 'parte_toca_no_validada' },
          { text: 'Solicitudes pendientes', value: 'parte_toca_pending' },
          { text: 'Notificaciones', value: 'notificaciones_count' },
          { text: 'Notificaciones (Partes no validadas)', value: 'notificaciones_parte_no_validada' },
          { text: 'Notificaciones Abiertas', value: 'notificaciones_opened' },
        ],
        totalesSalas: [],
    }
  },
  created() {
    this.$store.commit("SET_LAYOUT", "dashboard-layout");
  },
  computed: {
    ...mapGetters([
      "listRoles", //getters de roles.js
      "selectRoles",
      "roleUser",
      "currentUser"
    ]),
    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Usuario' : 'Editar Usuario'
    },
  },
  mounted() {
    // this.getSalas();
    this.getTotales();
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  methods: {
    sumField(key) {
        // sum data in give key (property)
        return this.totalesSalas.reduce((a, b) => a + (b[key] || 0), 0)
    },
    getSalas() {
      this.$store
        .dispatch("GET_SALAS")
        .then((response) => {
          this.salasList = response.data.salas;//usar response para datos, se puede usar getters
          console.log(response);
        })
        .catch(err => {
          console.log(err);
          //this.showAlert(this.notification);
        });
    },
    getTotales() {
      this.$store
        .dispatch("GET_TOTALES_BY_SALA")
        .then((response) => {
          this.totalesSalas = response.data.data.salas;//usar response para datos, se puede usar getters
          console.log( response.data.data.salas);
        })
        .catch(err => {
          console.log(err);
          //this.showAlert(this.notification);
        });
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.$refs.form.reset()
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.dialog = false
      }, 300)
    },
  }
}
</script>
